<template>
  <CRow v-if="platformPermissionsLoaded && checkPermission('loyalty.smartmoments.overview')">
    <CCol cols="12" lg="12">
      <loyaltySmartMoments :platformPermissions="platformPermissions" :modules="modules" :showHeader="true" :itemsPerPage="10"/>
    </CCol>
  </CRow>
  <noPermission v-else-if="platformPermissionsLoaded" trigger="permission"/>
</template>

<script>
import axios from 'axios'
import loadingSpinner from '@/components/common/loadingSpinner.vue';
import noPermission from '@/components/common/noPermission.vue';

import loyaltySmartMoments from '@/components/loyalty/loyaltySmartMoments.vue'

export default {
  name: 'SmartMoments',
  components: {
    loadingSpinner,
    noPermission,
    loyaltySmartMoments
  },
  data() {
    return {
      modules: {
        auto_moments: 0
      },
      platformPermissions: [],
      platformPermissionsLoaded: false
    }
  },
  methods: {
    getPlatformPermissions() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/permissions')
      .then(res => {      
        this.platformPermissions = res.data.data;
        // Update the platformPermissionsLoaded value
        this.platformPermissionsLoaded = true;
      })
      .catch(err => {
        console.error(err); 
      });
    },
    checkPermission(permissionTag) {
      if(this.platformPermissions.includes(permissionTag)) {
        return true;
      } else{
        return false;
      }
    },
    checkModules() {
      axios.get(process.env.VUE_APP_API_URL + '/v1/core/platform/modules')
      .then(res => {      
        this.modules = res.data.data;    
      })
      .catch(err => {
        console.error(err); 
      });
    }                    
  },
  mounted: function() {  
    this.checkModules();
    this.getPlatformPermissions();
  }
}
</script>